import type { DefaultOptionType } from 'antd/es/select';
import type { ShipmentRoutingTypesResponse } from './api';

export const normalizeShipmentRoutingTypes = (list: ShipmentRoutingTypesResponse): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
